export const config = {
  debugLogging: false,
  traceLogging: false,
  featureFlags: {
    proSpaceProfile: true,
    satisfactionPopup: false,
  },
  firebase: {
    authDomain: 'lvc-dev.lavitrine.com',
    projectId: 'lvc-dev',
    storageBucket: 'lvc-dev.appspot.com',
    messagingSenderId: '762500598686',
    appId: '1:762500598686:web:0ed3c13933eb68c255e48f',
    measurementId: 'G-4XGLBL2YGB',
  },
  algolia: {
    appId: 'DYK4PLEXJM',
    appUrl: 'https://{{{appId}}}-dsn.algolia.net/1/indexes/*/{{{fetchType}}}',
  },
  proSpaceUrl: {
    fr: 'https://pro-dev.lavitrine.com',
    en: 'https://pro-dev.lavitrine.com/en',
  },
  proSpaceDraftsUrl: {
    fr: 'https://pro-dev.lavitrine.com/fr/espace-pro/mes-brouillons',
    en: 'https://pro-dev.lavitrine.com/en/pro-zone/my-drafts',
  },
  backendApi: 'https://northamerica-northeast1-lvc-dev.cloudfunctions.net',
  geocodingApi: 'https://maps.googleapis.com/maps/api/geocode/json',
  recommendedContentFile:
    'https://storage.googleapis.com/lvc-dev-recommended-content/lvc-recommended-content.json',
  squidex: {
    contentApi: 'https://cloud.squidex.io/api/content/lvc-dev',
    clientId: 'lvc-dev:webcomponents',
    clientSecret: 'ggent7wh8sugvqru7wn8q3cltp0xztnast2dzmnl3fex',
  },
  mobileWidthThreshold: {
    lvcSearchWrapper: 1024,
  },
  eventSeriesCalendarConfig: {
    apiRoute: 'getEventSeriesEventOffers',
    pageId: '1',
  },
  routeGuard: [
    'profile',
    'profileCulture',
    'profileCultureCategory',
    'profileNotification',
    'profilePersonal',
    'profileFavorites',
    'profileSecurity',
    'partnerRegister',
    'partnerProfile',
    'partnerEventCreate',
    'eventCreation',
    'exhibitionCreation',
    'partnerCreateEvent',
    'partnerCreateExhibition',
    'partnerCreateFestival',
    'partnerCreateContribution',
    'partnerCreateContributor',
    'partnerDrafts',
  ],
  prospaceRouteGuard: [
    'partnerProfile',
    'partnerCreateEvent',
    'partnerCreateExhibition',
    'partnerCreateFestival',
    'partnerCreateContribution',
    'partnerCreateContributor',
    'partnerDrafts',
  ],
  ignoreRouteGuard: ['resetPassword', 'createPassword'],
  regionalSearchLocation: ['regionSearch'],
  skipProfileCompletion: ['partnerRegister'],
  routeProceedAfterSession: ['login', 'signup'],
  skipRouteLogging: [
    'login',
    'signup',
    'forgotPassword',
    'createPassword',
    'resetPassword',
    'profile',
    'profileCulture',
    'profileNotification',
    'profilePersonal',
    'completeSignup',
  ],
  routingHost: 'https://lvc-dev.lavitrine.com/',
  routingHomePageKey: 'homePage',
  routing: {
    en: {
      regionSearch: '/en/search/region',
      forgotPassword: '/en/forgot-password',
      resetPassword: '/en/account/reset-password',
      createPassword: '/en/account/create-password',
      login: '/en/login',
      signup: '/en/signup',
      completeSignup: '/en/complete-signup',
      completeAccountPreferences: '/en/complete-account-preferences',
      profile: '/en/account',
      profileCulture: '/en/account/cultural-profile',
      profileNotification: '/en/account/notifications',
      profilePersonal: '/en/account/personal-info',
      profileFavorites: '/en/account/favorites',
      profileSecurity: '/en/account/connections-and-security',
      search: '/search',
      searchResults: '/en/search',
      newsletter: '/newsletter',
      contactForm: '/contact-form',
      verifyExhibitionExistenceModal: '/en/verify-exhibition-existence-modal',
      discovery: '/en/discover',
      partnerRegister: '/en/pro-zone/register',
      partnerProfile: '/en/pro-zone/profile',
      partnerCreateEvent: '/en/pro-zone/create-an-event',
      partnerCreateExhibition: '/en/pro-zone/create-an-exhibition',
      partnerCreateFestival: '/en/pro-zone/create-a-festival',
      partnerCreateContribution: '/en/pro-zone/create-a-contribution',
      partnerCreateContributor: '/en/pro-zone/create-a-contributor',
      partnerDrafts: '/en/pro-zone/my-drafts',
      partnersPage: '/en/pro-zone',
      dataSharingPolicy: '/en/data-sharing-policy',
      privacyPolicy: '/en/privacy-policy',
      termsOfUse: '/en/terms-and-conditions',
      contributorsSelector: '/en/contributors-selector',
      homePage: '/en',
      resourcePage: '/en/resource-center',
    },
    fr: {
      regionSearch: '/fr/recherche/region',
      forgotPassword: '/fr/mot-de-passe-oublie',
      resetPassword: '/fr/compte/reinitialiser-mot-de-passe',
      createPassword: '/fr/compte/creer-mot-de-passe',
      login: '/fr/connexion',
      signup: '/fr/s-inscrire',
      completeSignup: '/fr/complete-inscription',
      completeAccountPreferences: '/fr/complete-compte-personnelles',
      profile: '/fr/compte',
      profileCulture: '/fr/compte/profil-culturel',
      profileNotification: '/fr/compte/notifications',
      profilePersonal: '/fr/compte/info-personnelles',
      profileFavorites: '/fr/compte/favoris',
      profileSecurity: '/fr/compte/connexion-et-securite',
      search: '/fr-search',
      searchResults: '/fr/recherche',
      newsletter: '/newsletter',
      contactForm: '/fr/contact-form',
      verifyExhibitionExistenceModal: '/fr/verify-exhibition-existence-modal',
      discovery: '/fr/decouvrir',
      partnerRegister: '/fr/espace-pro/s-inscrire',
      partnerProfile: '/fr/espace-pro/profil',
      partnerCreateEvent: '/fr/espace-pro/creer-un-evenement',
      partnerCreateExhibition: '/fr/espace-pro/creer-une-exposition',
      partnerCreateFestival: '/fr/espace-pro/creer-un-festival',
      partnerCreateContribution: '/fr/espace-pro/creer-une-contribution',
      partnerCreateContributor: '/fr/espace-pro/creer-un-contributeur',
      partnerDrafts: '/fr/espace-pro/mes-brouillons',
      partnersPage: '/fr/espace-pro',
      dataSharingPolicy: '/fr/politique-de-partage-des-donnees',
      privacyPolicy: '/fr/politique-de-confidentialite',
      termsOfUse: '/fr/conditions-d-utilisation',
      contributorsSelector: '/fr/contributors-selector',
      homePage: '',
      resourcePage: '/fr/centre-de-ressource',
    },
  },
  images: {
    eventStatusLabelMask:
      'https://uploads-ssl.webflow.com/636a96762b7e361f2abb7401/645e8fa3bd3ac9cf72e4ee62_lvc-calendar-flag.svg',
    globalMask:
      'https://cloud.squidex.io/api/assets/lvc-dev/fe761451-f306-46be-8d6c-e0344624278f/lvc-main-image-mask-16-9.svg?version=0',
    popupMask:
      'https://cloud.squidex.io/api/assets/lvc-dev/7f1c301f-a495-4763-9559-9c95543f2c6e/lvc-ec-popup-mask.svg?version=0',
  },
  searchAllModals: {
    events: 'events_search',
    exhibitions: 'exhibitions_search',
    festivals: 'festivals_search',
    eventSeries: 'eventseries_only',
    places: 'places_full',
    artists: 'artists',
  },
  ticketingServices: [
    { name: { en: 'AudienceView', fr: 'AudienceView' }, id: 'audienceView' },
    { name: { en: 'Evenko', fr: 'Evenko' }, id: 'evenko' },
    { name: { en: 'Eventbrite', fr: 'Eventbrite' }, id: 'eventbrite' },
    { name: { en: 'Feverup', fr: 'Feverup' }, id: 'feverup' },
    {
      name: { en: 'Le point de vente', fr: 'Le point de vente' },
      id: 'lePointDeVente',
    },
    { name: { en: 'Ovation', fr: 'Ovation' }, id: 'ovation' },
    {
      name: { en: 'Outbox Technology', fr: 'Outbox Technology' },
      id: 'outboxTechnology',
    },
    { name: { en: 'Réservatech', fr: 'Réservatech' }, id: 'reservatech' },
    { name: { en: 'TicketPro', fr: 'TicketPro' }, id: 'ticketpro' },
    { name: { en: 'Ticketacces', fr: 'Ticketacces' }, id: 'ticketacces' },
    { name: { en: 'Ticketmaster', fr: 'Ticketmaster' }, id: 'ticketmaster' },
    { name: { en: 'Tuxedo', fr: 'Tuxedo' }, id: 'tuxedo' },
    { name: { en: 'Weezevent', fr: 'Weezevent' }, id: 'weezevent' },
    { name: { en: 'Zeffy', fr: 'Zeffy' }, id: 'zeffy' },
    {
      name: {
        en: 'Independant ticketing service',
        fr: 'Billeterie indépendante',
      },
      id: 'independantTicketingService',
    },
    {
      name: { en: 'No ticketing service', fr: 'Pas de billeterie' },
      id: 'noTicketingService',
    },
    { name: { en: 'Other', fr: 'Autre' }, id: 'other' },
  ],
  priceTypes: [
    { name: { en: 'Starting from', fr: 'À partir de' }, id: 'startingFrom' },
    { name: { en: 'Fixed price', fr: 'Prix fixe' }, id: 'fixedPrice' },
  ],
  contributorTypes: [
    { name: { en: 'Moral Person', fr: 'Personne morale' }, id: 'moralPerson' },
    {
      name: { en: 'Physical person', fr: 'Personne physique' },
      id: 'physicalPerson',
    },
  ],
  contributionTypes: [
    { name: { en: 'Artist', fr: 'Artiste' }, id: 'artist' },
    {
      name: {
        en: 'Author, creator, or member of the creative team',
        fr: "Auteur, créateur ou membre de l'équipe de création",
      },
      id: 'authorCreatorOrMemberOfCreativeTeam',
    },
    {
      name: { en: 'Technical staff', fr: 'Personnel technique' },
      id: 'technicalStaff',
    },
  ],
  timezones: [
    { labelEn: 'Eastern Time', labelFr: "Heure de l'Est", id: 'ET' },
    { labelEn: 'Atlantic Time', labelFr: "Heure de l'Atlantique", id: 'AT' },
  ],
  culturalOrganizationTypes: [
    {
      labelEn:
        "Artist, artists' collective, artist(s) agency or creative company (self-represented artist or artist(s) representative or company in dance, theater, circus, etc.)",
      labelFr:
        "Artiste, collectif d'artistes, agence d'artiste(s) ou compagnie de création (artiste auto-représenté ou représentant d'artiste(s) ou compagnie de danse, théâtre, troupe de cirque, etc.)",
      id: 'artistCollectiveAgencyCompany',
    },
    {
      labelEn: 'Producer (show producer)',
      labelFr: 'Producteur',
      id: 'producer',
    },
    {
      labelEn: 'Presenter (multidisciplinary, specialized or alternative show presenter)',
      labelFr: 'Diffuseur (diffuseur de spectacles pluridisciplinaire, spécialisé ou alternatif)',
      id: 'presenter',
    },
    {
      labelEn: 'Venue manager (manager of one or more venues)',
      labelFr: 'Gestionnaire de salles',
      id: 'venueManager',
    },
    {
      labelEn: 'Sector or regional association (CRC)',
      labelFr: 'Association sectorielle ou régionale (CRC)',
      id: 'sectorRegionalAssociation',
    },
    {
      labelEn: 'Festival, major event / gathering',
      labelFr: 'Festival, grand événement / rassemblement',
      id: 'festivalMajorEvent',
    },
    {
      labelEn: 'Governmental or public institution (municipality, level of government, consulate)',
      labelFr:
        'Institution gouvernementale ou paragouvernementale (municipalité, palier de gouvernement, consulat)',
      id: 'governmentalInstitution',
    },
    {
      labelEn: 'Service provider (ticketing, promotion, consultant, etc.)',
      labelFr: 'Fournisseur de services (billetterie, promotion, consultant, etc.)',
      id: 'serviceProvider',
    },
    {
      labelEn: 'Media (journalist, photographer, radio, television, etc.)',
      labelFr: 'Média (journaliste, photographe, radio, télévision, etc.)',
      id: 'media',
    },
    {
      labelEn: 'Other (please specify)',
      labelFr: 'Autre',
      id: 'other',
    },
  ],
  searchConfigs: {
    searchCoreConfigs: {
      defaultCoreConfig: {
        index: [
          'events_search',
          'exhibitions_search',
          'festivals_search',
          'eventseries_only',
          'eventseries_search',
          'places_full',
          'artists',
        ],
        indexesWithGeo: [
          'events_search',
          'exhibitions_search',
          'festivals_search',
          'eventseries_only',
          'eventseries_search',
          'places_full',
        ],
        facetsAgnosticIndex: ['artists', 'places_full'],
        hitsPerPage: {
          events_search: 30,
          exhibitions_search: 0,
          eventseries_search: 0,
          places_full: 0,
          artists: 0,
          default: 30,
        },
        configs: {
          aroundRadius: {
            default: 10000,
            events_search: 10000,
            exhibitions_search: 10000,
            eventseries_search: 10000,
            eventseries_only: 10000,
            festivals_search: 10000,
            places_full: 10000,
          },
        },
        defaultQuery: '',
        defaultFacets: [],
      },
      lvcDisciplinesSection: {
        index: ['events_search'],
      },
      autocomplete: {
        index: [
          'events_search_autocomp',
          'festivals_autocomp',
          'places_full_autocomp',
          'artists_autocomp',
        ],
        hitsPerPage: {
          events_search_query_suggestions: 5,
          events_search: 5,
          exhibitions_search: 5,
          eventseries_search: 5,
          places_full: 5,
          artists: 5,
          default: 5,
        },
      },
      eventsNearMe: {
        index: ['events_search', 'exhibitions_search'],
        indexesWithGeo: ['events_search', 'exhibitions_search'],
        defaultQuery: '',
        defaultFacets: [],
        hitsPerPage: {
          events_search: 30,
        },
        configs: {
          aroundRadius: {
            events_search: 30000,
            exhibitions_search: 30000,
            default: 30000,
          },
        },
      },
      similarEvents: {
        index: ['events_search'],
        indexesWithGeo: ['events_search'],
        defaultQuery: '',
        defaultFacets: [],
        hitsPerPage: {
          default: 20,
          events_search: 20,
        },
      },
      recommendedEvents: {
        index: ['events_search'],
        indexesWithGeo: ['events_search'],
        defaultQuery: '',
        defaultFacets: [],
        hitsPerPage: {
          events_search: 30,
        },
      },
      eventsSearch: {
        index: ['espace_pro_events_search'],
        facetsAgnosticIndex: ['espace_pro_events_search'],
        hitsPerPage: {
          events: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [],
      },
      eventSeriesSearch: {
        index: ['eventseries_search'],
        facetsAgnosticIndex: ['eventseries_search'],
        hitsPerPage: {
          eventseries_search: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [],
      },
      eventsAndExhibitionSearch: {
        index: ['published_events', 'exhibitions_search'],
        facetsAgnosticIndex: ['published_events', 'exhibitions_search'],
        hitsPerPage: {
          espace_pro_events_search: 50,
          exhibitions_search: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [],
      },
      geolocation: {
        index: ['cities'],
        indexesWithGeo: ['cities'],
        defaultQuery: '',
        defaultFacets: [],
        hitsPerPage: {
          cities: 1000,
          default: 1000,
        },
      },
      contributorsSearch: {
        index: ['artists'],
        facetsAgnosticIndex: ['artists'],
        hitsPerPage: {
          artists: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [],
      },
      placesSearch: {
        index: ['places_full'],
        hitsPerPage: {
          places_full: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [
          {
            name: 'locationType',
            options: [
              {
                value: 'Place',
                selected: true,
                available: true,
              },
              {
                value: 'Sector',
                selected: true,
                available: true,
              },
            ],
          },
          {
            name: 'hasPublishedEvents',
            options: [
              {
                value: 'false',
                selected: true,
                available: true,
              },
              {
                value: 'true',
                selected: true,
                available: true,
              },
            ],
          },
        ],
      },
      virtualPlacesSearch: {
        index: ['places_full'],
        hitsPerPage: {
          places_full: 50,
          default: 50,
        },
        defaultQuery: '',
        defaultFacets: [
          {
            name: 'locationType',
            options: [
              {
                value: 'Virtual Location',
                selected: true,
                available: true,
              },
            ],
          },
          {
            name: 'hasPublishedEvents',
            options: [
              {
                value: 'false',
                selected: true,
                available: true,
              },
              {
                value: 'true',
                selected: true,
                available: true,
              },
            ],
          },
        ],
      },
      additionalTypesSearch: {
        index: ['additionalTypes'],
        hitsPerPage: {
          additionalTypes: 1000,
          default: 1000,
        },
        defaultQuery: '',
        defaultFacets: [
          {
            name: 'vocabularyName',
            options: [
              {
                value: 'V1TaxoDiscVitrine',
                selected: true,
                available: true,
              },
            ],
          },
        ],
      },
    },
  },
  slidersConfigs: {
    everyone: {
      maxDaysToFilter: 30,
      facets: [
        {
          name: 'audience',
          options: [
            {
              available: true,
              selected: true,
              value: 'General',
            },
          ],
        },
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    familyFriendly: {
      maxDaysToFilter: 30,
      facets: [
        {
          name: 'audience',
          options: [
            {
              available: true,
              selected: true,
              value: 'Family',
            },
            {
              available: true,
              selected: true,
              value: 'Toddler',
            },
            {
              available: true,
              selected: true,
              value: 'Childhood',
            },
            {
              available: true,
              selected: true,
              value: 'Children',
            },
          ],
        },
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    free: {
      maxDaysToFilter: 30,
      facets: [
        {
          name: 'isAccessibleForFree',
          options: [
            {
              value: 'true',
              selected: true,
              available: true,
            },
          ],
        },
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    nearMe: {
      maxDaysToFilter: 30,
      facets: [
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    recommended: {
      maxDaysToFilter: 30,
      facets: [
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    series: {
      index: ['eventseries_search'],
      modal: 'eventseries_search',
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        eventseries_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    thisWeek: {
      facets: [
        {
          name: 'table',
          options: [
            {
              value: 'eventOffers',
              selected: true,
              available: true,
            },
          ],
        },
      ],
      hitsPerPage: {
        events_search: 30,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
    expositions: {
      maxDaysToFilter: 30,
      hitsPerPage: {
        events_search: 0,
        exhibitions_search: 30,
        places_full: 0,
        artists: 0,
      },
    },
  },
}
